import { combineReducers } from 'redux';

import {
    RECEIVE_PAYMENT_REQUESTS,
    REQUEST_PAYMENT_REQUESTS,
    FAILURE_PAYMENT_REQUESTS
} from './constants';

const requests = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_PAYMENT_REQUESTS:
            return action.response.payload;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_PAYMENT_REQUESTS:
            return true;
        case FAILURE_PAYMENT_REQUESTS:
        case RECEIVE_PAYMENT_REQUESTS:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_PAYMENT_REQUESTS:
            return action.response.message;
        case REQUEST_PAYMENT_REQUESTS:
        case RECEIVE_PAYMENT_REQUESTS:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    requests,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/ongoing/reducer.js